interface SpinnerProps {
  label?: string;
}

/** A minimal, accessible loading indicator. `label` is announced to screen readers. */
export function Spinner({ label = "Loading…" }: SpinnerProps): JSX.Element {
  return (
    <div className="spinner" role="status" aria-live="polite">
      <span className="spinner__ring" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
